export default __webpack_public_path__ + "static/media/card5.83cd6956.jpg";